import Button from 'components/crm/ui/Button';
import Modal from 'components/crm/ui/Modal';
import { useEffect } from 'react';

// Mounted while open only, so that its Escape listener lives with it.
const Confirmation = ({
  title,
  description,
  cancelLabel,
  confirmLabel,
  busy,
  onCancel,
  onConfirm,
}) => {
  // The Modal closes on Escape; marked handled first, so that a slide-over
  // around it stays open.
  useEffect(() => {
    const onKeyDown = (event) =>
      event.key === 'Escape' && event.preventDefault();
    window.addEventListener('keydown', onKeyDown, true);
    return () => window.removeEventListener('keydown', onKeyDown, true);
  }, []);

  return (
    <Modal
      open
      onClose={onCancel}
      title={title}
      description={description}
      width={420}
      footer={
        <>
          <Button variant="secondary" onClick={onCancel}>
            {cancelLabel}
          </Button>
          <Button
            disabled={busy}
            aria-busy={busy || undefined}
            onClick={onConfirm}
          >
            {confirmLabel}
          </Button>
        </>
      }
    />
  );
};

/**
 * Asks before a gesture of a record page that cannot be undone from there
 * (a company out of its group, a group contact deleted). The confirm button
 * calls `onConfirm`; the cancel button, Escape or the backdrop `onCancel`.
 */
const ConfirmDialog = ({ open, busy = false, ...props }) =>
  open ? <Confirmation busy={busy} {...props} /> : null;

export default ConfirmDialog;
